import React, { FC, ReactNode } from 'react';
import MuiBox, { BoxProps } from '@mui/material/Box';
import { styled, SxProps, Theme } from '@mui/material/styles';
import { colors, sizes } from 'src/themes/default';
import { Paper } from '@mui/material';
import Stack from '@mui/material/Stack';

type FormActionType = { onClick: () => void; icon?: ReactNode; label?: string };
type FormActionsPropsType = { actions: FormActionType[] };
type FormBlockPropsType = { children: ReactNode; actions?: FormActionType[]; sx?: SxProps<Theme> };

const Box = styled(MuiBox)<BoxProps>(({ theme }) => ({
    backgroundColor: colors.background_B0,
    borderRadius: sizes.radius,
    display: 'flow-root',
    padding: '16px 24px',
}));

const FormActions: FC<FormActionsPropsType> = (props) => <Stack spacing={2} direction="row"></Stack>;

const FormBlock: FC<FormBlockPropsType> = (props) => (
    <Box sx={{ flexGrow: 1, ...(props.sx || {}) }}>
        {props.actions && <FormActions actions={props.actions} />}
        {props.children}
    </Box>
);

export default FormBlock;
